import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsInt, IsNotEmpty, IsOptional, IsString, Min } from 'class-validator';
import { PromotionExposeGroup, PromotionTargetTypeEnum } from '../interface';
export class PutPromotionTargetDto {
    constructor() {
        this.quantity = 1;
    }
}
__decorate([
    ApiProperty({
        enum: PromotionTargetTypeEnum,
        description: `type of discount target: ${Object.values(PromotionTargetTypeEnum).join(' | ')}`,
        example: PromotionTargetTypeEnum.ITEM,
    }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsEnum(PromotionTargetTypeEnum, { always: true }),
    __metadata("design:type", String)
], PutPromotionTargetDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'uuid of discount target', example: 'f2f94d64-3928-4eb4-b3fd-15cc23c6d096' }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PutPromotionTargetDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'quantity of added item', default: 1 }),
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT, PromotionExposeGroup.FIXTURE] }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    __metadata("design:type", Number)
], PutPromotionTargetDto.prototype, "quantity", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ, PromotionExposeGroup.CREATE, PromotionExposeGroup.PUT] }),
    IsOptional({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PutPromotionTargetDto.prototype, "storeId", void 0);
//# sourceMappingURL=PutPromotionTargetDto.js.map